// Progressive reveal for .reveal elements; respects prefers-reduced-motion.
export function initReveal(root = document) {
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const nodes = root.querySelectorAll('.reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    nodes.forEach((n) => n.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      }
    },
    // threshold 0 with a bottom margin: a fraction-of-element threshold never fires for sections taller than the viewport.
    { threshold: 0, rootMargin: '0px 0px -10% 0px' }
  );
  nodes.forEach((n) => io.observe(n));
}
